import { render, staticRenderFns } from "./emailHeaderEditor.vue?vue&type=template&id=2c349a8a&scoped=true&"
import script from "./emailHeaderEditor.vue?vue&type=script&lang=js&"
export * from "./emailHeaderEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c349a8a",
  null
  
)

export default component.exports